import { TextContent } from '@amzn/awsui-components-react';
import { ReactNode } from 'react';
import CardContainer from '../components/CardContainer';
import ContainerLayout from '../components/ContainerLayout';
import Footer from '../components/Footer';
import { getLogoutInstructions } from '../components/idps';
import Main from '../components/Main';
import TopHeader from '../components/TopHeader';
import { requiredLogoutUrlParams } from '../constants/providers';
import { LAST_USED_PROVIDER_KEY } from '../constants/storage';
import providersService from '../services/providers';
import { localStorageAdapter } from '../services/storage';
import { AppConfig } from '../types/app';

export const Logout = ({ config }: { config: AppConfig }) => {
  const clientID = providersService.getClientId(requiredLogoutUrlParams);
  const { lastProviderName } = JSON.parse(
    localStorageAdapter.getItem(LAST_USED_PROVIDER_KEY) || '{}'
  );
  let providerDisplayName = '';
  let instructions: ReactNode | undefined;
  if (lastProviderName) {
    const logoutInfo = getLogoutInstructions(lastProviderName);
    providerDisplayName = logoutInfo?.displayName;
    instructions = logoutInfo?.instructions;
  }
  const lxpName = config.clients[clientID].displayName;
  const header = `You're signed out ${lxpName ? `of ${lxpName}` : ''}`;
  const instructionContainer = providerDisplayName ? (
    <TextContent>
      You may be logged in with <b>{providerDisplayName}</b>.{instructions}
    </TextContent>
  ) : (
    <TextContent>
      To completely sign out, logout from your Enterprise SSO.
    </TextContent>
  );
  return (
    <>
      <TopHeader />
      <Main>
        <ContainerLayout>
          {
            <CardContainer header={header}>
              {instructionContainer}
            </CardContainer>
          }
        </ContainerLayout>
      </Main>
      <Footer />
    </>
  );
};
